/**
 * @copyright (C) 2023-2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-06-29 15:48:56
 **/

// forked from packages/frameworks/libraries/src/exposes/network/usePnsManager.ts
import { useEffect, useRef } from "react";
import Network, { NetworkStatic } from "./network";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOGTAG = "#useStompManager#";

export default function useStompManager(pnsName = "default") {
	const network = useRef<NetworkStatic>(Network.instances[pnsName]);

	useEffect(() => {
		if (pnsName !== "default") {
			if (!Network.instances[pnsName]) {
				Network.instances[pnsName] = new NetworkStatic();
				console.debug(LOGTAG, "Create a new network with", pnsName);
			}
			network.current = Network.instances[pnsName];
		}
	}, []);

	return network.current;
}
